<template>
	<div>
		<leftNav class='leftNav' />
		<topBar class='topBar' ref='tb' :htmlon='htmlon'/>
		<!-- <appMain class='appMain' /> -->
		<router-view  ref='phone' class='appMain'/>
	</div>
</template>

<script>
	import leftNav from "./components/leftNav"
	import topBar from "./components/topBar"
	import appMain from "./components/topBar"
	export default{
		components:{
			leftNav,topBar,appMain
		},
		data(){
			return{
      	presetLine: [{ type: 'l', site: 100 }, { type: 'v', site: 200 }],
				htmlon:0
			}
		},
		mounted(){
			window.$tb = this.$refs.tb
			window.$p = this.$refs.phone
		}
	}
</script>

<style lang="scss">
@import "../../styles/colors.scss";
.leftNav{
	height: 100%;
	width: $left_width;
	background: #273239;
	position: absolute;
	left: 0;
	top: 0;
	z-index: 3;
}
.logo{
	width: 100%;
	height: $top_height;
	background: #2e3c45;
	color: #fff;
	overflow: hidden;
}
.logo img{
	height: 100%;
}
.topBar{
	width: calc(100% - 70px);
	margin-left: $left_width;
	height: $top_height;
	position: absolute;
	top: 0;
	left: 0;
	box-shadow: 0 1px 4px 0 rgba(0,0,0,0.15);
	z-index: 2;
	background: #fff;
}
.appMain{
	z-index: 1;
	width: calc(100vw - 70px);
	height: calc(100vh - 70px);
	position: absolute;
	background: rgb(240, 240, 240);
	top: $top_height;
	left: $left_width;
}
</style>


// WEBPACK FOOTER //
// src/views/laout/laout.vue